import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const IMPERSONATE_STORAGE_KEY = "financelocal:imp_token";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Restore impersonation header on cold start (AuthContext will validate w/ server).
try {
  const tok = window.localStorage.getItem(IMPERSONATE_STORAGE_KEY);
  if (tok) api.defaults.headers.common["X-Impersonate-Token"] = tok;
  // One-time cleanup of removed UI-only view-as-role flag (now unified into impersonation).
  window.localStorage.removeItem("financelocal:view_as_role");
} catch { /* ignore */ }

export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);
export const fmtMoney2 = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n || 0);
export const fmtPct = (n) => `${(n || 0).toFixed(1)}%`;

export const CATEGORY_LABELS = {
  performing: "Performing",
  semi_performing: "Semi-Performing",
  non_performing: "Non-Performing",
  repo_ready: "Repo Ready",
  fresh_origination: "Fresh Origination",
};
export const CATEGORIES = Object.keys(CATEGORY_LABELS);

export const STATUS_BADGE = {
  performing: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300 border border-emerald-300 dark:border-emerald-800",
  semi_performing: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300 border border-amber-300 dark:border-amber-800",
  non_performing: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300 border border-orange-300 dark:border-orange-800",
  repo_ready: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300 border border-red-300 dark:border-red-800",
  fresh_origination: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300 border border-blue-300 dark:border-blue-800",
};

export const GRADE_BADGE = {
  A: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300 border border-emerald-300 dark:border-emerald-800",
  B: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300 border border-blue-300 dark:border-blue-800",
  C: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300 border border-amber-300 dark:border-amber-800",
  D: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300 border border-red-300 dark:border-red-800",
};
